import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  List,
  ListItem,
  ListItemText,
  Typography,
} from "@mui/material";
import React from "react";
import ShowComplementsList from "./ShowComplementsList";

const ShowComplements = ({
  produto,
  saveProdutosBuscados,
  produtosBuscados,
}) => {
  return (
    <Box>
      {produto.complementos
        .filter((complementos) => complementos.tipoComplemento !== "TAMANHO")
        .map((complementos) => (
          <React.Fragment key={complementos.id}>
            <Box paddingTop={1}>
              <Accordion square>
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                  <ListItem dense>
                    <ListItemText
                      dense
                      primary={
                        <Typography color="textPrimary" variant="button">
                          {complementos.descricao}
                        </Typography>
                      }
                      secondary={
                        <Typography color="textSecondary" variant="body1">
                          Qtd. min. {complementos.min} | Qtd. Máx.{" "}
                          {complementos.max}
                          {complementos.obrigatorio
                            ? " (obrigatório)"
                            : " (opcional)"}
                        </Typography>
                      }
                    />
                  </ListItem>
                </AccordionSummary>

                <AccordionDetails sx={{ padding: "0", margin: "0" }}>
                  <List dense={true} style={{ width: "100%" }}>
                    <Box sx={{ paddingX: "2rem" }}>
                      {complementos.complementoItens.map(
                        (complementoItem, index) => (
                          <ShowComplementsList
                            complementoItem={complementoItem}
                            produto={produto}
                            complementos={complementos}
                            index={index}
                            produtosBuscados={produtosBuscados}
                            saveProdutosBuscados={saveProdutosBuscados}
                          />
                        )
                      )}
                    </Box>
                  </List>
                </AccordionDetails>
              </Accordion>
            </Box>
          </React.Fragment>
        ))}
    </Box>
  );
};

export default ShowComplements;
